module.exports = __webpack_public_path__ + "img/edit_art_effects.6636b94.png";